import React from "react";
import {
  StickyNote,
  TriangleAlert,
  X,
  CheckCircle,
  Sparkles,
  MessageCircle,
  Settings,
} from "lucide-react";
// Reuse the same CSS file 5565 Starting

const InstanceMessage_Simplifyte_Notes = () => {
  return (
    <section className="instance-message-simplifyte-notes">
      {/* Background blobs */}
      <div className="instance-message-simplifyte-notes-bg">
        <div className="instance-message-simplifyte-notes-blob instance-message-simplifyte-notes-blob-1"></div>
        <div className="instance-message-simplifyte-notes-blob instance-message-simplifyte-notes-blob-2"></div>
      </div>

      <div className="instance-message-simplifyte-notes-container">
        {/* Header */}
        <div className="instance-message-simplifyte-notes-header">
          <div className="instance-message-simplifyte-notes-badge">
            <div className="instance-message-simplifyte-notes-badge-icon-wrapper">
              <StickyNote className="instance-message-simplifyte-notes-badge-icon" />
            </div>
            <span className="instance-message-simplifyte-notes-badge-text">
              Simple Notes
            </span>
          </div>

          <h2 className="instance-message-simplifyte-notes-title">
            Important Notes That
            <br />
            <span className="instance-message-simplifyte-notes-gradient">
              Never Get Lost
            </span>
          </h2>

          <p className="instance-message-simplifyte-notes-subtitle">
            Keep audit case notes organized and accessible. Both team and
            clients can add important details that won't disappear in endless
            chat scrolling.
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="instance-message-simplifyte-notes-comparison">
          {/* Old Way */}
          <div className="instance-message-simplifyte-notes-old-way">
            <div className="instance-message-simplifyte-notes-old-header">
              <div className="instance-message-simplifyte-notes-old-icon-wrapper">
                <TriangleAlert className="instance-message-simplifyte-notes-old-icon" />
              </div>
              <div>
                <h3 className="instance-message-simplifyte-notes-old-title">
                  Old Way
                </h3>
                <p className="instance-message-simplifyte-notes-old-subtitle">
                  Lost in endless chats
                </p>
              </div>
            </div>

            <div className="instance-message-simplifyte-notes-old-list">
              <div className="instance-message-simplifyte-notes-old-item">
                <X className="instance-message-simplifyte-notes-old-item-icon" />
                <p className="instance-message-simplifyte-notes-old-item-text">
                  Important details buried in 1000+ messages
                </p>
              </div>
              <div className="instance-message-simplifyte-notes-old-item">
                <X className="instance-message-simplifyte-notes-old-item-icon" />
                <p className="instance-message-simplifyte-notes-old-item-text">
                  Endless scrolling to find critical information
                </p>
              </div>
              <div className="instance-message-simplifyte-notes-old-item">
                <X className="instance-message-simplifyte-notes-old-item-icon" />
                <p className="instance-message-simplifyte-notes-old-item-text">
                  Lost deadlines and missed requirements
                </p>
              </div>
              <div className="instance-message-simplifyte-notes-old-item">
                <X className="instance-message-simplifyte-notes-old-item-icon" />
                <p className="instance-message-simplifyte-notes-old-item-text">
                  Confusion about what was agreed upon
                </p>
              </div>
            </div>
          </div>

          {/* Simpliflow Way */}
          <div className="instance-message-simplifyte-notes-new-way">
            <div className="instance-message-simplifyte-notes-new-bg-blob"></div>
            <div className="instance-message-simplifyte-notes-new-content">
              <div className="instance-message-simplifyte-notes-new-header">
                <div className="instance-message-simplifyte-notes-new-icon-wrapper">
                  <StickyNote className="instance-message-simplifyte-notes-new-icon" />
                </div>
                <div>
                  <h3 className="instance-message-simplifyte-notes-new-title">
                    Simplifyte Way
                  </h3>
                  <p className="instance-message-simplifyte-notes-new-subtitle">
                    Always accessible
                  </p>
                </div>
              </div>

              <div className="instance-message-simplifyte-notes-new-list">
                <div className="instance-message-simplifyte-notes-new-item">
                  <CheckCircle className="instance-message-simplifyte-notes-new-item-icon" />
                  <p className="instance-message-simplifyte-notes-new-item-text">
                    Important notes pinned at the top
                  </p>
                </div>
                <div className="instance-message-simplifyte-notes-new-item">
                  <CheckCircle className="instance-message-simplifyte-notes-new-item-icon" />
                  <p className="instance-message-simplifyte-notes-new-item-text">
                    Instant access from chat header
                  </p>
                </div>
                <div className="instance-message-simplifyte-notes-new-item">
                  <CheckCircle className="instance-message-simplifyte-notes-new-item-icon" />
                  <p className="instance-message-simplifyte-notes-new-item-text">
                    Never miss deadlines or requirements
                  </p>
                </div>
                <div className="instance-message-simplifyte-notes-new-item">
                  <CheckCircle className="instance-message-simplifyte-notes-new-item-icon" />
                  <p className="instance-message-simplifyte-notes-new-item-text">
                    Clear audit trail for both parties
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Chat Preview */}
        <div className="instance-message-simplifyte-notes-chat-preview">
          <div className="instance-message-simplifyte-notes-chat-header">
            <div className="instance-message-simplifyte-notes-chat-user">
              <div className="instance-message-simplifyte-notes-chat-avatar">
                SW
              </div>
              <div>
                <h3 className="instance-message-simplifyte-notes-chat-name">
                  Sarah Williams
                </h3>
                <div className="instance-message-simplifyte-notes-chat-status">
                  <span className="instance-message-simplifyte-notes-chat-status-dot"></span>
                  <span className="instance-message-simplifyte-notes-chat-status-text">
                    Online
                  </span>
                </div>
              </div>
            </div>

            <div className="instance-message-simplifyte-notes-chat-actions">
              <button className="instance-message-simplifyte-notes-chat-notes-btn">
                <div className="instance-message-simplifyte-notes-chat-notes-icon-wrapper">
                  <StickyNote className="instance-message-simplifyte-notes-chat-notes-icon" />
                </div>
                <span className="instance-message-simplifyte-notes-chat-notes-text">
                  Notes
                </span>
                <span className="instance-message-simplifyte-notes-chat-notes-badge">
                  3
                </span>
              </button>

              <button className="instance-message-simplifyte-notes-chat-settings-btn">
                <Settings className="instance-message-simplifyte-notes-chat-settings-icon" />
              </button>
            </div>
          </div>

          <div className="instance-message-simplifyte-notes-chat-messages">
            {/* Message 1 */}
            <div className="instance-message-simplifyte-notes-message instance-message-simplifyte-notes-message-left">
              <div className="instance-message-simplifyte-notes-message-avatar">
                SW
              </div>
              <div className="instance-message-simplifyte-notes-message-content">
                <div className="instance-message-simplifyte-notes-message-bubble">
                  <p className="instance-message-simplifyte-notes-message-text">
                    Hi, I've uploaded all the documents for the March quarter
                    audit. Can you review them?
                  </p>
                  <span className="instance-message-simplifyte-notes-message-time">
                    10:30 AM
                  </span>
                </div>
              </div>
            </div>

            {/* Message 2 */}
            <div className="instance-message-simplifyte-notes-message instance-message-simplifyte-notes-message-right">
              <div className="instance-message-simplifyte-notes-message-content">
                <div className="instance-message-simplifyte-notes-message-bubble instance-message-simplifyte-notes-message-bubble-right">
                  <p className="instance-message-simplifyte-notes-message-text">
                    Perfect! I'll review them today. Quick question - what's the
                    deadline for filing?
                  </p>
                  <span className="instance-message-simplifyte-notes-message-time">
                    10:32 AM
                  </span>
                </div>
              </div>
              <div className="instance-message-simplifyte-notes-message-avatar">
                PS
              </div>
            </div>

            {/* Message 3 */}
            <div className="instance-message-simplifyte-notes-message instance-message-simplifyte-notes-message-left">
              <div className="instance-message-simplifyte-notes-message-avatar">
                SW
              </div>
              <div className="instance-message-simplifyte-notes-message-content">
                <div className="instance-message-simplifyte-notes-message-bubble">
                  <p className="instance-message-simplifyte-notes-message-text">
                    The deadline is 15th May. I'll add it to our notes so we
                    don't forget!
                  </p>
                  <span className="instance-message-simplifyte-notes-message-time">
                    10:35 AM
                  </span>
                </div>
              </div>
            </div>

            {/* Notes Callout */}
            <div className="instance-message-simplifyte-notes-callout">
              <div className="instance-message-simplifyte-notes-callout-icon-wrapper">
                <StickyNote className="instance-message-simplifyte-notes-callout-icon" />
              </div>
              <div className="instance-message-simplifyte-notes-callout-text">
                <p className="instance-message-simplifyte-notes-callout-main">
                  Click the{" "}
                  <span className="instance-message-simplifyte-notes-callout-highlight">
                    Notes
                  </span>{" "}
                  button above to see the magic →
                </p>
                <p className="instance-message-simplifyte-notes-callout-sub">
                  Try adding, viewing, and managing notes
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="instance-message-simplifyte-notes-features">
          <div className="instance-message-simplifyte-notes-feature">
            <div className="instance-message-simplifyte-notes-feature-icon instance-message-simplifyte-notes-feature-icon-cyan">
              <Sparkles className="instance-message-simplifyte-notes-feature-icon-svg" />
            </div>
            <h4 className="instance-message-simplifyte-notes-feature-title">
              Both Parties
            </h4>
            <p className="instance-message-simplifyte-notes-feature-text">
              Team and clients can both add and view notes
            </p>
          </div>

          <div className="instance-message-simplifyte-notes-feature">
            <div className="instance-message-simplifyte-notes-feature-icon instance-message-simplifyte-notes-feature-icon-amber">
              <CheckCircle className="instance-message-simplifyte-notes-feature-icon-svg" />
            </div>
            <h4 className="instance-message-simplifyte-notes-feature-title">
              Never Lost
            </h4>
            <p className="instance-message-simplifyte-notes-feature-text">
              Always accessible from the chat header
            </p>
          </div>

          <div className="instance-message-simplifyte-notes-feature">
            <div className="instance-message-simplifyte-notes-feature-icon instance-message-simplifyte-notes-feature-icon-purple">
              <MessageCircle className="instance-message-simplifyte-notes-feature-icon-svg" />
            </div>
            <h4 className="instance-message-simplifyte-notes-feature-title">
              Visual Distinction
            </h4>
            <p className="instance-message-simplifyte-notes-feature-text">
              Color-coded by author type for easy identification
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstanceMessage_Simplifyte_Notes;
